// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--setting-outlet-root {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  position: relative;
  padding: 10px 130px 20px 130px;
  box-sizing: border-box;
}

.scl--setting-outlet-breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
}

.scl--setting-outlet-breadcrumb-home {
  display: flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  font-size: var(--font-size-12, 12px);
  color: var(--typography-text-body-secondary, #8A8B8F);
  transition: color 0.15s ease;
}

.scl--setting-outlet-breadcrumb-home:hover {
  color: var(--typography-text-body-primary, #323539);
}

.scl--setting-outlet-breadcrumb-sep {
  font-size: var(--font-size-12, 12px);
  color: var(--typography-text-body-secondary, #8A8B8F);
}

.scl--setting-outlet-breadcrumb-icon {
  display: flex;
  align-items: center;
}

.scl--setting-outlet-breadcrumb-current {
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  font-size: var(--font-size-12, 12px);
  color: var(--typography-text-body-secondary, #8A8B8F);
}

.scl--setting-outlet-title {
  font-family: var(--font-family-inter, 'Inter', sans-serif);
  font-size: var(--font-size-36, 36px);
  font-weight: bold;
  line-height: var(--line-height-40, 40px);
  color: var(--typography-text-body-primary, #323539);
  margin: 0 0 15px 0;
  letter-spacing: 1px;
}

.scl--setting-outlet-content {
  flex: 1;
  width: 100%;
}



`, "",{"version":3,"sources":["webpack://./src/layout-controller-mod/layout-serv/outlet/css/settingOutlet.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,0DAA0D;EAC1D,oCAAoC;EACpC,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0DAA0D;EAC1D,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,0DAA0D;EAC1D,oCAAoC;EACpC,iBAAiB;EACjB,wCAAwC;EACxC,mDAAmD;EACnD,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,WAAW;AACb","sourcesContent":[".scl--setting-outlet-root {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100%;\n  position: relative;\n  padding: 10px 130px 20px 130px;\n  box-sizing: border-box;\n}\n\n.scl--setting-outlet-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n\n.scl--setting-outlet-breadcrumb-home {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  font-size: var(--font-size-12, 12px);\n  color: var(--typography-text-body-secondary, #8A8B8F);\n  transition: color 0.15s ease;\n}\n\n.scl--setting-outlet-breadcrumb-home:hover {\n  color: var(--typography-text-body-primary, #323539);\n}\n\n.scl--setting-outlet-breadcrumb-sep {\n  font-size: var(--font-size-12, 12px);\n  color: var(--typography-text-body-secondary, #8A8B8F);\n}\n\n.scl--setting-outlet-breadcrumb-icon {\n  display: flex;\n  align-items: center;\n}\n\n.scl--setting-outlet-breadcrumb-current {\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  font-size: var(--font-size-12, 12px);\n  color: var(--typography-text-body-secondary, #8A8B8F);\n}\n\n.scl--setting-outlet-title {\n  font-family: var(--font-family-inter, 'Inter', sans-serif);\n  font-size: var(--font-size-36, 36px);\n  font-weight: bold;\n  line-height: var(--line-height-40, 40px);\n  color: var(--typography-text-body-primary, #323539);\n  margin: 0 0 15px 0;\n  letter-spacing: 1px;\n}\n\n.scl--setting-outlet-content {\n  flex: 1;\n  width: 100%;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
